<template>
    <div class="container">
        <router-view />
    </div>
</template>
<script>
export default {
    name: "Layout",
    components: {},
};
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
}
</style>